import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Logo, Link } from 'anf-core-react';
import { useCookies } from 'react-cookie';
import clsx from 'clsx';
import $window from '../../../tools/window';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import { MiniBagIconButton } from '../../MiniBag/MiniBagWithIcon/MiniBagWithIcon';

function PurchaseSiteHeader({ spacer = false }) {
  const [cookie] = useCookies();
  const {
    checkoutPageState,
  } = useContext(CheckoutPageContext);
  const { search, hostname } = $window.location;
  const searchParams = new URLSearchParams(search);
  const usePurxHeader = searchParams.get('usePurxHeader') === '1';
  const isSticky = searchParams.get('isStickyHeader') === 'true';
  const storeId = searchParams.get('storeId');
  const parts = hostname.split('.');
  const domain = parts.length > 2 ? parts.at(-2) : parts[0];

  const cacheKey = `af-minicart-${storeId}`;
  const itemsInBagFromCookies = Number.isNaN(Number(cookie?.[cacheKey]))
    ? 0 : Number(cookie?.[cacheKey]);

  const {
    bagItems,
    textFor = {},
  } = checkoutPageState;
  const itemsInBag = bagItems?.items?.length || itemsInBagFromCookies;
  const buttonClassName = 'minibag-nav-smallscreen minibag-nav-smallscreen-mfe';
  const dataTestId = 'minibag-icon';
  const spanDataTestId = 'mini-bag-item-count';

  const handleOnMiniBagIconClick = () => {
    $window.location.href = $window.location.href.replace(
      'OrderCheckoutDisplayView',
      'OrderItemDisplayView',
    );
  };

  if (!usePurxHeader) {
    // If the header is not needed, return null
    return null;
  }

  if (spacer) {
    // If spacer is true, return a div with a specific class
    return (
      <div
        className={clsx('purx-site-header__spacer', { 'non-sticky': !isSticky })}
        data-testid="purx-site-header__spacer"
      />
    );
  }

  // If the header is needed, return the header component
  return (
    <header
      className={clsx('purx-site-header', { 'non-sticky': !isSticky })}
      data-testid="purx-site-header"
    >
      <div className="purx-site-header__container">
        <div className="header-icon">
          <Link
            href="/"
            classList="header-icon__link"
          >
            <Logo kind={domain === 'hollisterco' ? 'hco' : 'anf'} />
          </Link>
        </div>
        <MiniBagIconButton
          dataTestId={dataTestId}
          spanDataTestId={spanDataTestId}
          buttonClassName={buttonClassName}
          itemsInBag={itemsInBag}
          textFor={textFor}
          onClick={handleOnMiniBagIconClick}
        />
      </div>
    </header>
  );
}

PurchaseSiteHeader.defaultProps = {
  spacer: false,
};

PurchaseSiteHeader.propTypes = {
  spacer: PropTypes.bool,
};

export default PurchaseSiteHeader;
